import { useState } from "react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import { CalendarIcon, X } from "lucide-react";

function fmt(d) {
    if (!d) return "";
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function toIsoDate(d) {
    return d ? fmt(d) : "";
}

const PRESETS = [
    { label: "今天", getRange: () => { const t = new Date(); return { from: t, to: t }; } },
    { label: "近 7 天", getRange: () => { const t = new Date(); const s = new Date(); s.setDate(t.getDate() - 6); return { from: s, to: t }; } },
    { label: "近 30 天", getRange: () => { const t = new Date(); const s = new Date(); s.setDate(t.getDate() - 29); return { from: s, to: t }; } },
    { label: "本月", getRange: () => { const t = new Date(); const s = new Date(t.getFullYear(), t.getMonth(), 1); return { from: s, to: t }; } },
    { label: "上月", getRange: () => { const t = new Date(); const s = new Date(t.getFullYear(), t.getMonth() - 1, 1); const e = new Date(t.getFullYear(), t.getMonth(), 0); return { from: s, to: e }; } },
    { label: "本年", getRange: () => { const t = new Date(); const s = new Date(t.getFullYear(), 0, 1); return { from: s, to: t }; } },
];

export default function DateRangePicker({ value, onChange }) {
    const [open, setOpen] = useState(false);
    const label = value?.from
        ? value.to && value.to.getTime() !== value.from.getTime()
            ? `${fmt(value.from)} → ${fmt(value.to)}`
            : fmt(value.from)
        : "全部日期";

    const applyPreset = (p) => {
        const range = p.getRange();
        onChange(range);
        setOpen(false);
    };

    return (
        <div className="flex items-center gap-2">
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        data-testid="date-range-btn"
                        variant="outline"
                        className="justify-start gap-2 font-mono text-sm h-10 min-w-[220px]"
                    >
                        <CalendarIcon className="h-4 w-4 text-gold-500" />
                        {label}
                    </Button>
                </PopoverTrigger>
                <PopoverContent align="start" className="p-0 w-auto flex">
                    <div className="border-r border-slate-200 p-2 flex flex-col gap-1 w-32">
                        {PRESETS.map((p) => (
                            <button
                                key={p.label}
                                data-testid={`date-preset-${p.label}`}
                                onClick={() => applyPreset(p)}
                                className="text-left text-sm px-3 py-1.5 rounded hover:bg-slate-100 text-slate-700 transition-colors"
                            >
                                {p.label}
                            </button>
                        ))}
                    </div>
                    <div>
                        <Calendar
                            mode="range"
                            selected={value}
                            onSelect={onChange}
                            numberOfMonths={2}
                            initialFocus
                        />
                    </div>
                </PopoverContent>
            </Popover>
            {value?.from && (
                <Button
                    data-testid="clear-date-range-btn"
                    variant="ghost"
                    size="sm"
                    onClick={() => onChange(undefined)}
                    className="h-9 text-gold-500 hover:text-slate-900 gap-1"
                >
                    <X className="h-3.5 w-3.5" /> 清除
                </Button>
            )}
        </div>
    );
}
